export enum TutorialVideoLink {
    DASHBOARD = "https://blancco.storylane.io/share/bmp-dashboard",
    BMS_CONFIG = "https://blancco.storylane.io/demo/bmp-bmsconfig",
    BMPOP = "https://blancco.storylane.io/demo/bmp-bmpop",
    TENANTS = "https://blancco.storylane.io/demo/bmp-tenants",
    USERS_AND_ROLES = "https://blancco.storylane.io/demo/bmp-usersroles",
    LICENSES = "https://blancco.storylane.io/demo/bmp-licenses",
    WORKFLOWS = "https://blancco.storylane.io/demo/bmp-workflows",
    REPORTS = "https://blancco.storylane.io/demo/bmp-reports",
    SUSTAINABILITY = "https://blancco.storylane.io/demo/bmp-sustainability",
    HOME = "https://blancco.storylane.io/demo/bmp-home",
}
